"use client";

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import React from "react";
import MotionHighlight from "@/components/effects/MotionHighlight";
import type { AccordionProps } from "../types";

function Accordion({ children, ...props }: AccordionProps) {
  return (
    <MotionHighlight hover controlledItems className="bg-accent">
      <AccordionPrimitive.Root data-slot="accordion" {...props}>
        {children}
      </AccordionPrimitive.Root>
    </MotionHighlight>
  );
}

Accordion.displayName = "Accordion";

export default Accordion;
